export default __webpack_public_path__ + "static/media/head01_zh_tw_pc.4a4ddc88.png";